import type { AxiosInstance } from 'axios';
import type { ApiEmptyResponse } from '@/service/api/types';

export default (axiosInstance: AxiosInstance) => ({

    /**
   * @description check service work correctly
   *
   * @tags common
   * @name authCheck
   * @request GET:/auth-check
   * @secure
   * @response `default` `ApiEmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any content answers
   */
    async authCheck() {
        const res = await axiosInstance.get<ApiEmptyResponse>('/auth-check');
        return res.data;
    },

    /**
   * @description check service work correctly
   *
   * @tags common
   * @name healthCheck
   * @request GET:/health-check
   * @response `default` `ApiEmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any content answers
   */
    async healthCheck() {
        const res = await axiosInstance.get<ApiEmptyResponse>('/health-check');
        return res.data;
    },

    /**
   * @description request subscribe to mailing list
   *
   * @tags common
   * @name subscribe
   * @request POST:/subscribe
   * @response `default` `null`
   */
    async subscribe(email: string, name: string) {
        const params = {
            /** @format email */
            email,
            name
        };

        const res = await axiosInstance.post(
            '/subscribe',
            {},
            { params }
        );
        return res.data;
    }
} as const);
